<template>
  <section class="match-detail-rules-section">
    <div class="rules-background" aria-hidden="true">
      <div class="rules-bg-schedule-continued"></div>
      <div class="rules-bg-segment rules-bg-first"></div>
      <div class="rules-bg-segment rules-bg-following rules-bg-second"></div>
      <div class="rules-bg-segment rules-bg-following rules-bg-third"></div>
      <div class="rules-bg-mask"></div>
    </div>

    <img class="rules-character" :src="matchDetailRulesSectionData.characterImage" alt="" />

    <div class="rules-title">
      <img :src="matchDetailRulesSectionData.titleImage" alt="赛事规则" />
    </div>

    <template v-if="signupRule">
      <div class="rules-block rules-block-signup">
        <div class="rule-label">
          <img :src="matchDetailRulesSectionData.signupLabelImage" alt="" />
          <div class="rule-label-text">{{ signupRule.title }}</div>
        </div>

        <div class="rule-content">
          <p v-for="item in signupRule.content" :key="item" class="rule-paragraph">
            {{ item }}
          </p>
        </div>
      </div>
    </template>

    <template v-if="battleRule">
      <div class="rules-block rules-block-battle">
        <div class="battle-rule-label">
          <img :src="matchDetailRulesSectionData.battleLabelImage" alt="" />
          <div class="battle-rule-label-text">{{ battleRule.title }}</div>
        </div>

        <div class="battle-rule-content">
          <p v-for="(item, index) in battleRule.content" :key="index" class="battle-rule-paragraph">
            {{ item }}
          </p>
        </div>
      </div>
    </template>

    <template v-if="matchRule && promotionRule">
      <div class="rules-block rules-block-match">
        <div class="match-rule-label">
          <img :src="matchDetailRulesSectionData.signupLabelImage" alt="" />
          <div class="match-rule-label-text">{{ matchRule.title }}</div>
        </div>

        <div class="match-rule-content">
          <p v-for="(item, index) in matchRule.content" :key="index" class="match-rule-paragraph">
            {{ item }}
          </p>
          <p class="match-rule-paragraph"></p>
          <p class="match-rule-paragraph">{{ promotionRule.title }}</p>
          <p v-for="(item, index) in promotionRule.content" :key="`promotion-${index}`" class="match-rule-paragraph">
            {{ item }}
          </p>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { matchDetailRuleBlocks, matchDetailRulesSectionData } from '@/data/match/matchDetail'

export default {
  name: 'MatchDetailRulesSection',
  data() {
    return { matchDetailRulesSectionData }
  },
  computed: {
    signupRule() { return matchDetailRuleBlocks.find(item => item.id === 'signup-rule') },
    battleRule() { return matchDetailRuleBlocks.find(item => item.id === 'battle-rule') },
    matchRule() { return matchDetailRuleBlocks.find(item => item.id === 'match-rule') },
    promotionRule() { return matchDetailRuleBlocks.find(item => item.id === 'promotion-rule') },
  },
}
</script>

<style scoped lang="scss">
.match-detail-rules-section {
  position: relative;
  z-index: 0;
  box-sizing: border-box;

  .rules-background {
    position: absolute;
    z-index: 0;
    inset: 0;
    overflow: hidden;
    pointer-events: none;

    .rules-bg-segment {
      position: absolute;
      right: 0;
      left: 0;
      height: 5.625rem;
      background-position: center top;
      background-repeat: no-repeat;
      background-size: cover;
    }

    // The schedule background continues to the Figma 11.25rem seam.
    .rules-bg-schedule-continued {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      height: 0.369792rem;
      background: url('@/assets/image/match/pc/match/news-section-bg.png') center bottom / cover no-repeat;
    }

    .rules-bg-first {
      top: 0.369792rem;
      background-image: url('@/assets/image/match/pc/match/progress-section-bg.png');
    }

    .rules-bg-following {
      height: 13.3vw;
      background-image: url('@/assets/image/match/pc/match/detail-rules-bg.png');
    }

    .rules-bg-second {
      top: 5.994792rem;
    }

    .rules-bg-third {
      height:10rem /* 1920/192 */;
      height:13rem;
      top: 7.239583rem /* 1390/192 */;
      // background-image: url('@/assets/image/match/pc/match/detail-schedule-bg.png');
    }

    .rules-bg-mask {
      position: absolute;
      right: 0;
      top: 17.244792rem;
      left: 0;
      height: 1.328125rem;
      background: url('@/assets/image/match/pc/match/Maskgroup.png') center top / cover no-repeat;
      background:transparent;
    }
  }

  .rules-character {
    position: absolute;
    top: 0.630208rem;
    right: 0;
    left: auto;
    z-index: 0;
    width: 5.958333rem;
    height: 3.921875rem;
    opacity: 0.8;
    pointer-events: none;
  }

  .rules-title,
  .rule-label,
  .rule-content {
    position: relative;
    z-index: 1;
    margin-right: auto;
    margin-left: auto;
  }

  .rules-title {
    width: 6.880208rem;
    height: 0.869792rem;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.869792rem;
      object-fit: contain;
    }
  }

  .rule-label {
    width: 1.666667rem;
    height: 0.40625rem;
    margin-top: 0.213542rem;

    img {
      display: block;
      width: 1.666667rem;
      height: 0.40625rem;
    }

    .rule-label-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1.666667rem;
      height: 0.161458rem;
      color: #ffd9ac;
      font-size: 0.135417rem;
      font-weight: 700;
      line-height: 0.161458rem;
      text-align: center;
    }
  }

  .rule-content,
  .battle-rule-content,
  .match-rule-content {
    width: 6.776042rem;
    color: #000000;
    font-size: 0.104167rem;
    font-weight: 600;
    line-height: 0.208333rem;
  }

  .rule-content {
    margin-top: 0.265625rem;
  }

  .rule-paragraph,
  .battle-rule-paragraph,
  .match-rule-paragraph {
    min-height: 0.208333rem;
    margin: 0;
    line-height: 0.208333rem;
    white-space: pre-wrap;
  }

  .battle-rule-label {
    position: relative;
    z-index: 1;
    width: 2.5rem;
    height: 0.40625rem;
    margin: 0.364583rem auto 0;

    img {
      display: block;
      width: 2.5rem;
      height: 0.40625rem;
    }

    .battle-rule-label-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 2.5rem;
      height: 0.161458rem;
      color: #ffd9ac;
      font-size: 0.135417rem;
      font-weight: 700;
      line-height: 0.161458rem;
      text-align: center;
    }
  }

  .battle-rule-content {
    position: relative;
    z-index: 1;
    margin: 0.401042rem auto 0;
  }

  .match-rule-label {
    position: relative;
    z-index: 1;
    width: 1.666667rem;
    height: 0.40625rem;
    margin: 0.177083rem auto 0;

    img {
      display: block;
      width: 1.666667rem;
      height: 0.40625rem;
    }

    .match-rule-label-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 1.666667rem;
      height: 0.197917rem;
      color: #ffd9ac;
      font-size: 0.135417rem;
      font-weight: 700;
      line-height: 0.197917rem;
      text-align: center;
    }
  }

  .match-rule-content {
    position: relative;
    z-index: 1;
    margin: 0.411458rem auto 0;
    padding-bottom: 1.125rem;
  }

  @media (max-width: 750px) {
    background: transparent;

    .rules-background {
      display: none;
    }

    .rules-character {
      display: none;
    }

    .rules-block {
      display: flow-root;
      background-position: center top;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .rules-block-battle {
      background-image: none;
    }

    .rules-block-match {
      // background-image: none;
      background-image: url('@/assets/image/match/pc/match/detail-schedule-bg.png');
      padding-bottom:13.3vw;
    }

    .rules-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .rule-label,
    .match-rule-label {
      width: 40%;
      height: auto;
      margin-top: 7vw;

      img {
        width: 100%;
        height: auto;
      }

      .rule-label-text,
      .match-rule-label-text {
        width: 100%;
        height: auto;
        font-size: 3.5vw;
        line-height: 1.2;
      }
    }

    .battle-rule-label {
      width: 66%;
      height: auto;
      margin-top: 7vw;

      img {
        width: 100%;
        height: auto;
      }

      .battle-rule-label-text {
        width: 100%;
        height: auto;
        font-size: 3.5vw;
        line-height: 1.2;
      }
    }

    .rule-content,
    .battle-rule-content,
    .match-rule-content {
      width: 94%;
      margin-top: 8vw;
      font-size: 3.2vw;
      line-height: 1.8;
      padding-bottom: 0;

      .rule-paragraph,
      .battle-rule-paragraph,
      .match-rule-paragraph {
        min-height: 0;
        line-height: 1.8;
      }
    }
  }
}
</style>
